export const environment = {
  production: true,
  api: {
    url: '/api',
    tokenEndpoint: '/oauth/token',
    revokeEndpoint: '/oauth/revoke',
    clientId: 'webfrontend',
    clientSecret: 'webfrontend'
  },
  version: '2.24.5'
};
